import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers} from '../../views/textNumber-input/text-number';
import {specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import MenuContext from '../../../context/menuContext';
import {useMenu} from '../../../hooks/useMenu';
import SaveConstant from './set-password';
import ConstantBatch from './constant-batch';

function ConstantBatchTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {selected, onComponent} = useMenu();

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={53}
      defaultKey4={1}
      defaultKey5={53}
      defaultKey6={65}
      defaultKey7={53}
      defaultKey8={1}
      defaultKey9={53}
      defaultKey10={65}
      defaultKey11={53}
      defaultKey12={1}
      onSave={() => onComponent(<SaveConstant initiallyDisableKeypress />)}
      onLeftHold={() => onComponent(<ConstantBatch initiallyDisableKeypress />)}
      title="Enter Constant Batch Mode"
      caption="Set the password required to exit"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default ConstantBatchTN;
